// /terms — the terms of service, including the SMS program terms A2P 10DLC
// campaign vetting requires. Public and bare, same reasoning as privacy.ts.

import { type View } from '../router.js';
import { el } from '../dom.js';
import { authBrand } from './authBrand.js';

export const termsView: View = (outlet) => {
  outlet.append(
    el('main', { class: 'page' }, [
      authBrand(),
      el('h1', {}, 'Terms and Conditions'),
      el('p', {}, 'Last updated: October 15, 2026'),

      el('h2', {}, 'The service'),
      el('p', {}, [
        'MySocialCal (the "Service") lets a group (a poker night, a hiking ',
        'club, a book club, a sports league, or anything similar) schedule ',
        'events, track RSVPs, share photos, and log results. By creating an ',
        'account you agree to these terms.',
      ]),

      el('h2', {}, 'Your account'),
      el('p', {}, [
        'You are responsible for the accuracy of the information you provide ',
        'and for activity that happens under your account. You must be old ',
        'enough in your country to enter into this agreement.',
      ]),

      el('h2', {}, 'Acceptable use'),
      el('p', {}, [
        'Do not use the Service to harass another member, post content you ',
        'do not have the right to share, or attempt to disrupt or gain ',
        'unauthorized access to the Service. A group admin may remove a ',
        'member or content that violates this, and we may suspend an ',
        'account for the same reasons.',
      ]),

      el('h2', {}, 'SMS program terms'),
      el('p', {}, [
        'MySocialCal ("the program") may send you text messages if you ',
        'provide a phone number and confirm it by entering a code we text ',
        'you: a verification code, group invitations, and the notifications ',
        'you choose to receive by text: event announcements, day-of "still ',
        'coming?" prompts, headcount and RSVP summaries for events you ',
        'organize, notices that an event is on or full, notices of new posts ',
        'and event chat messages in your groups, and join requests for groups ',
        'you manage.',
      ]),
      el('p', {}, [
        el('strong', {}, 'Message frequency varies'),
        ' with how many groups you are in, how often they meet and post, ',
        'and which notifications you turn on: typically a few messages per ',
        'active group per month, more if you turn on posts or chat in a busy ',
        'group.',
      ]),
      el('p', {}, ['Message and data rates may apply.']),
      el('p', {}, [
        'Reply ',
        el('strong', {}, 'STOP'),
        ' at any time to stop receiving text messages. Reply ',
        el('strong', {}, 'HELP'),
        ' for help, or contact us at the address below. Carriers are not ',
        'liable for delayed or undelivered messages.',
      ]),

      el('h2', {}, 'Photos and content you post'),
      el('p', {}, [
        'You keep ownership of what you post. By uploading a photo or ',
        'posting to a group, you allow the Service to store and display it ',
        'to that group’s members as part of providing the Service.',
      ]),

      el('h2', {}, 'Disclaimer'),
      el('p', {}, [
        'The Service is provided "as is," without warranty of any kind. We ',
        'are not responsible for the conduct of any group, its organizer, or ',
        'its members, or for events, RSVPs, or results scheduled or recorded ',
        'through the Service.',
      ]),

      el('h2', {}, 'Changes'),
      el('p', {}, [
        'We may update these terms as the Service changes. Continuing to use ',
        'the Service after an update means you accept the revised terms.',
      ]),

      el('h2', {}, 'Contact us'),
      el('p', {}, [
        'Questions about these terms, or to reach support: ',
        el('a', { href: '/contact' }, 'contact us'),
        '.',
      ]),
      el('p', {}, [
        'See also our ',
        el('a', { href: '/privacy' }, 'Privacy Policy'),
        '.',
      ]),

      el('p', { class: 'signed-out-only' }, [el('a', { href: '/login' }, 'Back to log in')]),
    ]),
  );
};
